import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { toast } from 'react-toastify';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import { formatNumber, splitByUppercase, stringIsNullOrEmpty } from '../Common/Utilities';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import ServerExportWrapper from '../Common/DataGridServerExportWrapper';
import { MUIButton } from '../Common/Components/MuiButton';
import { getFilter, setFilter } from '../Common/Utilities';
import { getGridNumericOperators } from '@mui/x-data-grid';

const numberFilterOperators = getGridNumericOperators().map((op) => {
	const labelMap = {
		'=': 'is equal to',
		'!=': 'is not equal to',
		'>': 'is greater than',
		'>=': 'is greater than or equal to',
		'<': 'is less than',
		'<=': 'is less than or equal to',
		'isEmpty': 'is empty',
		'isNotEmpty': 'is not empty',
	};
	return { ...op, label: labelMap[op.value] ?? op.label };
});

export default class VendorInvoicesWithPaymentStatusReport extends React.Component {
	constructor() {
		super();

		const persisted = getFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport']) || {};
		var userInfo = JSON.parse(localStorage["userInfo"]);
		var modelDefId = persisted.modelDefId ?? this.getDefaultModelDefId(userInfo);


		const nineWeeksAgo = new Date();
		nineWeeksAgo.setDate(nineWeeksAgo.getDate() - 63);

		const defaultFilterModel = {
			items: [{
				field: 'invoiceDate',
				operator: 'after',
				value: nineWeeksAgo.toISOString().split('T')[0]
			}],
			logicOperator: 'and'
		};

		this.state = {
			data: [],
			modelDefId: modelDefId,
			userInfo: userInfo,
			filterText: persisted.filterText ?? '',
			lastFilterText: '',
			columnVisibility: persisted.columnVisibility || {},
			filterModel: persisted.filterModel ?? defaultFilterModel,
			tempTableEnabled: false,
			exportData: [],
			dataLoaded: false,
			isServerMode: false,
			hasSearched: persisted.hasSearched ?? false,
			sortModel: persisted.sortModel || [],
			defaultFilter: { ...defaultFilterModel.items[0] }

		};
		this.mainGridRef = React.createRef();


		this.modelDefId_changeHandler = this.modelDefId_changeHandler.bind(this);
		this.getDefaultModelDefId = this.getDefaultModelDefId.bind(this);
		this.getInvoiceTypeMenuItem = this.getInvoiceTypeMenuItem.bind(this);
		this.searchCallback = this.searchCallback.bind(this);
		this.getSearchButton = this.getSearchButton.bind(this);
		this.getFilterItems = this.getFilterItems.bind(this);
		this.fieldInModel = this.fieldInModel.bind(this);
		this.normalizeFilterModel = this.normalizeFilterModel.bind(this);
	}

	getDefaultModelDefId(userInfo) {
		if (!stringIsNullOrEmpty(userInfo.invoiceType)) {
			if (userInfo.invoiceType.includes('1')) {
				return 1;
			}
			else if (userInfo.invoiceType.includes('2')) {
				return 2;
			}
		}
	}

	componentDidMount() {
		const gridRef = this.mainGridRef?.current;

		const { filterModel, filterText, modelDefId, hasSearched } = this.state;
		gridRef.setFilterModel({
			...filterModel,
			quickFilterValues: ['']
		});
		if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
			gridRef.setQuickFilterValues([filterText]);
		}
		this.fetchVendorInvoicesWithPaymentStatus(modelDefId, filterModel, hasSearched ? filterText : '');

		setFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport'], {
			...getFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport']),
			hasSearched,
			filterText,
			modelDefId,
			filterModel,
			columnVisibility: this.state.columnVisibility
		});
	}


	modelDefId_changeHandler(event) {
		const modelDefId = parseInt(event.target.value, 10);

		const {
			filterModel,
			filterText,
			hasSearched,
			columnVisibility,
			lastFilterText,
		} = this.state;

		this.setState({
			data: [],
			modelDefId,
			filterModel,
			filterText,
			lastFilterText,
			hasSearched,
		}, () => {

			this.mainGridRef.current?.setFilterModel({
				...filterModel,
				quickFilterValues: [filterText || ''],
			});


			const stored = getFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport']) || {};
			setFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport'], {
				...stored,
				modelDefId,
				filterModel,
				filterText,
				columnVisibility,
				hasSearched,
			});


			this.fetchVendorInvoicesWithPaymentStatus(
				modelDefId,
				filterModel,
				hasSearched ? filterText : ''
			);
		});
	}


	fetchVendorInvoicesWithPaymentStatus(modelDefId, filterModel, searchText, exportData) {
		var that = this;

		this.props.inProgress(true);
		let _uFilterModel = this.getFilterItems(filterModel);
		httpPost('/api/reports/vendorinvoiceswithpaymentstatus/',
			{
				searchFilter: searchText,
				otherFilters: JSON.stringify((_uFilterModel.items || []).
					map(f => ({
						field: splitByUppercase(f.field).join('_'),
						operator: f.operator,
						value: (f.operator === 'isEmpty' || f.operator === 'isNotEmpty') ? true : f.value,
					}))
					.filter(f => f.value !== undefined && f.value !== '')),
				logicOperator: _uFilterModel.logicOperator,
				ModelDefId: modelDefId,
				isAll: !!exportData
			})
			.then((response) => {
				//var data = response.data;
				var data = (response.data || []).map((e, i) => { let d = { ...e, rowId: i }; return d });

				if (!!exportData) {
					that.setState({ ...this.state, exportData: data, dataLoaded: true });
				}
				else {
					that.setState({ data: data });
				}

				this.props.inProgress(false);
			})
			.catch((error) => {
				this.props.inProgress(false);
				if (!!exportData) {
					that.setState({ ...this.state, tempTableEnabled: false });
				}
				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}

	getInvoiceTypeMenuItem(modelDefId, displayValue) {
		if (this.state.userInfo.invoiceType.includes('' + modelDefId)) {
			return <MenuItem value={modelDefId}>{displayValue}</MenuItem>
		}
	}
	displayVendorName(rowData) {
		return stringIsNullOrEmpty(rowData.vendorName) ? rowData.vendorCode : rowData.vendorName;
	}
	searchCallback = (searchText) => {
		const trimmedText = (searchText || "").trim();
		const prevText = this.state.lastFilterText;
		if (trimmedText === "" && prevText !== "") {
			this.setState({ lastFilterText: "" }, () => {
				this.fetchVendorInvoicesWithPaymentStatus(this.state.modelDefId, this.state.filterModel, searchText);

			});
			return;
		}
		if (trimmedText !== "" && trimmedText !== prevText) {
			this.setState({ lastFilterText: trimmedText }, () => {
				this.fetchVendorInvoicesWithPaymentStatus(this.state.modelDefId, this.state.filterModel, searchText);

			});
		}
	}

	getFilterItems(filterModel) {
		//const hasInvoiceDateFilter = this.fieldInModel(filterModel, 'invoiceDate');
		//let _filterModel = structuredClone(filterModel);

		//if (this.state.isServerMode && !hasInvoiceDateFilter) {
		//	_filterModel.items = _filterModel.items || [];
		//	_filterModel.logicOperator = _filterModel.logicOperator || 'and';
		//	_filterModel.items.push(this.state.defaultFilter);
		//}

		//return _filterModel;
		return filterModel;
	}
	getSearchButton() {
		const { filterModel } = this.state;
		const isInvoiceDateFiltered = this.fieldInModel(filterModel, 'invoiceDate');

		if (!isInvoiceDateFiltered) {
			return (
				<MUIButton
					color="primary"
					size="medium"
					sx={{ marginTop: '12px', marginRight: '4px' }}
					text="Click here to filter records"
					onClick={() => {
						this.fetchVendorInvoicesWithPaymentStatus(this.state.modelDefId, this.state.filterModel, this.state.filterText);
					}}
				/>
			);
		}
		return null;
	}
	fieldInModel(model, fieldName) {
		const relevantOperators = ['after', 'onOrAfter', 'before', 'onOrBefore'];
		return model.items?.some(f =>
			f.field === fieldName && (
				!f.operator || relevantOperators.includes(f.operator)
			)
		);
	}
	normalizeFilterModel(model) {
		return {
			items: [...(model?.items || [])],
			logicOperator: model?.logicOperator || 'and'
		};
	}

	handleFilterPanelSearch = (incomingFilterModel, quickFilterText = '') => {

		const normalizedModel = this.normalizeFilterModel(incomingFilterModel);
		//const isServerMode = !this.fieldInModel(normalizedModel, 'invoiceDate');

		this.setState({
			filterModel: normalizedModel,
			filterText: quickFilterText,
			hasSearched: true
			//isServerMode
		}, () => {
			setFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport'], {
				filterModel: normalizedModel,
				filterText: quickFilterText,
				modelDefId: this.state.modelDefId,
				columnVisibility: this.state.columnVisibility,
				hasSearched: true,
			});
			// ✅ Now it will fetch data
			this.fetchVendorInvoicesWithPaymentStatus(this.state.modelDefId, normalizedModel, quickFilterText);
		});
	};


	render() {
		const lookup =
			[
				'Unpaid',
				'Partially Paid',
				'Fully Paid'
			];

		const cellStyle = { paddingRight: 45 };
		const filterCellStyle = { textAlign: 'right', paddingRight: 45 };
		const headerStyle = { textAlign: 'right' };
		var columns = [
			{
				headerName: 'Vendor Name',
				field: 'vendorName',
				renderCell: rowData => { return this.displayVendorName(rowData.row); },
				flex: 1,
				hideable: false
			},
			{
				headerName: 'Vendor Invoice Number',
				field: 'invoiceNumber',
				flex: 1
			},
			{
				headerName: 'Vendor Invoice Date',
				field: 'invoiceDate',
				type: 'date',
				valueGetter: ({ value }) => value && new Date(value),
				flex: 1
			},
			{
				headerName: 'Last Approved By',
				field: 'approvedBy',
				flex: 1
			}];
		if (this.state.modelDefId === 2) {
			columns.push({
				headerName: 'Job',
				field: 'jobCode',
				//hide: (this.state.modelDefId !== 2),
				flex: 1
			},
				{
					headerName: 'Activity',
					field: 'activityCode',
					//hide: (this.state.modelDefId !== 2),
					flex: 1
				});
		}
		else {
			columns.push({
				headerName: 'Campaign Name',
				field: 'campaignName',
				//hide: (this.state.modelDefId === 2)
			},
				{
					headerName: 'Media Plan',
					field: 'mediaPlanName',
					//hide: (this.state.modelDefId === 2),
					flex: 1
				});
		}
		columns.push(
			{
				headerName: (this.state.modelDefId === 2 ? 'PO' : 'IO'),
				flex: 1,
				field: 'ioNumber'
			},
			{
				headerName: 'Amount',
				field: 'amount',
				type: 'number',
				align: 'right',
				headerAlign: 'right',
				flex: 1,
				filterOperators: numberFilterOperators,
				renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.amount) + " " + (rowData.row.currencyCode || "")}</span>,
				valueFormatter: (scope) => {
					const row = scope.row || (scope.api && scope.api.getRow(scope.id));
					return formatNumber(row?.amount) + " " + (row?.currencyCode || "");
				},
				getExportValue: (row) => formatNumber(row.amount) + " " + (row.currencyCode || "")
			},
			{
				headerName: 'Posted Date',
				field: 'postedDate',
				type: 'date',
				valueGetter: ({ value }) => value && new Date(value),
				flex: 1
			},
			{
				headerName: 'Payment Status',
				field: 'paymentStatus',
				type: 'singleSelect',
				valueOptions: lookup,
				flex: 1
			},
			{
				headerName: 'Payment Amount',
				field: 'paymentAmount',
				type: 'number',
				align: 'right',
				headerAlign: 'right',
				flex: 1,
				filterOperators: numberFilterOperators,
				renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.paymentAmount) + " " + (rowData.row.currencyCode || "")}</span>,
				valueFormatter: (scope) => {
					const row = scope.row || (scope.api && scope.api.getRow(scope.id));
					return formatNumber(row?.paymentAmount) + " " + (row?.currencyCode || "");
				},
				getExportValue: (row) => formatNumber(row.paymentAmount) + " " + (row.currencyCode || "")
			},
			{
				headerName: 'Payment Info',
				field: 'paymentInfo',
				flex: 1
			},
			{
				headerName: 'Transaction Id',
				field: 'transactionId',
				flex: 1
			});
		let filterMode = this.state.isServerMode ? { filterMode: 'server' } : {};
		return (
			<div>
				<h1>Vendor Invoices With Payment Status</h1>
				<div className="form-group">
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							columns={columns}
							customcomponent={
								<>
									<Select
										variant='standard'
										style={{ float: "right", zIndex: 1, marginTop: 2, marginRight: 10 }}
										value={this.state.modelDefId}
										onChange={this.modelDefId_changeHandler}
										sx={{
											backgroundColor: "rgba(0, 140, 205, 0.25)",
											"&.Mui-focused": {
												backgroundColor: "rgba(0, 140, 205, 0.25)",
											},
										}}
									>
										{this.getInvoiceTypeMenuItem(1, 'Media')}
										{this.getInvoiceTypeMenuItem(2, 'Production')}
									</Select>
									{/*this.getSearchButton()*/}
								</>
							}
							options={{
								pageSize: 10,
								pageSizeOptions: [10, 20, 30, 40, 50],
								maxBodyHeight: 670,
								filtering: true,
								columnsButton: true,
								exportButton: true,
								exportAllData: true,
								exportFileName: "VendorInvoicesWithPaymentStatus"
							}}
							gridRef={this.mainGridRef}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
							{...filterMode}
							serverExcel={false}
							customFilterPanel={true}
							searchCallback={null}
							setFilterText={(text) => {

								const trimmedText = text?.trim() || '';
								const stored = getFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport']) || {};
								if (trimmedText === stored.filterText) return;
								const shouldResetSearch = stored.hasSearched && stored.filterText !== trimmedText;
								const nextHasSearched = shouldResetSearch ? false : stored.hasSearched;

								this.setState({ ...this.state, filterText: trimmedText, hasSearched: nextHasSearched })
								setFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport'], {
									...stored,
									filterText: trimmedText,
									hasSearched: nextHasSearched
								});
							}}
							highlightSearchTextOnMainScreenGrid={true}
							onColumnVisbilityModelChange={(model) => {
								this.setState({ columnVisibility: model });
								setFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport'], {
									...getFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport']),
									columnVisibility: model,
								});
							}}
							columnVisibilityModel={this.state.columnVisibility}
							onSortModelChange={(model) => {
								this.setState({ sortModel: model });
								setFilter(['Reports', 'VendorInvoicesWithPaymentStatusReport', 'sortModel'], model);
							}}
							sortModel={this.state.sortModel}
							onFilterPanelSearch={(filterModel, quickFilterText) => {
								this.handleFilterPanelSearch(filterModel, quickFilterText);
							}}
							setFilterModel={(model) => {
								//this.setState({
								//	filterModel: { items: [...model.items], logicOperator: model.logicOperator },
								//}, () => {
								//	this.mainGridRef.current?.setFilterModel({
								//		...model,
								//		quickFilterValues: [this.state.filterText]
								//	});
								//});
							}}
							customServerFilter={() => this.state.isServerMode ? () => { } : undefined}
							exportServerCallback={() => {
								this.setState(prev => {
									return { ...prev, tempTableEnabled: true }
								}, () => {
									this.fetchVendorInvoicesWithPaymentStatus(this.state.modelDefId, this.state.filterModel, this.state.filterText, true);
								})
							}}
							footerMessage={''}
						/>
					</div>
					{
						this.state.tempTableEnabled ?

							<ServerExportWrapper
								rows={this.state.exportData}
								initialState={{
									columns: {
										columnVisibilityModel: {
											...this.mainGridRef.current.exportState().columns.columnVisibilityModel
										},
									},
								}}
								columns={columns}
								options={{
									exportFileName: "VendorInvoicesWithPaymentStatus"
								}}
								dataLoaded={this.state.dataLoaded}
								getRowId={(row) => row.rowId}
								resetStates={() => {
									this.setState({
										...this.state,
										tempTableEnabled: false,
										dataLoaded: false,
										exportData: []
									})
								}}
							/>
							:
							<></>
					}
				</div>
			</div>
		);
	}
}